import React from 'react';
import { translate, Trans } from 'react-i18next';
import { Feed, Icon,Button, Image } from 'semantic-ui-react';

import Utils from '../../utils/Utils.js';
import {colors, fontSizes, fonts, spacings, layout, shadow, shadowLight} from 'style';



const Palette = {
    primary: colors.themeBlue,
    secondary: colors.themeTeal,
    points: colors.pointsYellow,
    body: colors.themeDarkerGrey,
    subtext: colors.themeDarkGrey,
    warning: colors.warningRed
};

const Sizes = {
    caption: '12px',
    subtext: '14px',
    body: '16px',
    header: '18px',
    title: '20px',
    h2: '24px',
    h1: '32px',
    x1: '40px'
}

const Margins = {
    default: '16',
    none: '0',
    micro: '1',
    mini: '2',
    tiny: '4',
    small: '8',
    medium: '16',
    large: '24',
    xlarge: '32',
    xxlarge: '48',
    xxxlarge: '64',
}

const Alignments = {
    left: 'left',
    center: 'center',
    right: 'right'
}


const Render0Block = ({t, content, onAction}) => (
    Boolean(content.asset) && <div style={{backgroundImage: 'url(' + content.asset.url + ')', backgroundRepeat: 'round', height: '524px', 
                ...(Utils.deref(content, 'navigation') ? {cursor: 'pointer'} : {})}} 
                onClick={()=>onAction(Utils.deref(content, 'navigation', null))} />
);

export default Render0Block;


// WEBPACK FOOTER //
// ./src/modules/newsfeed/Render0Block.js